export default __webpack_public_path__ + "static/media/signupForm.af66632d.JPG";